import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import axios from "axios";
import { Base_url, Base_url_bbbs } from "../config";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import bigInt from "big-integer";

let Fraud = () => {
  let [data, setData] = useState();

  let navigate = useNavigate();

  let [name, setName] = useState();
  let [indexs, setIndex] = useState(0);
  let [sel, setSel] = useState("All");
  const [selectedRadio, setSelectedRadio] = useState("phone");
  let [value, inputvalue] = useState();

  useEffect(() => {
    Start(); 
  }, []);

  let Start = async () => {
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
    }
  };

  let User = async () => {


    console.log(name , 'nameeeeeeeeeeeeee')

    if( name  === "" ){
      alert("Please Enter data");
      return;
    }
  
     try {
 
       let pp = { type : selectedRadio, data : name  };
 
       let apicall = await axios({
         method: "post",
         url: Base_url + "/gst/fraudd",
         data: pp,
       })
         .then((dat) => {
           alert("Success");
         })
         .catch((ee) => {
           alert(" Failed");
         });
     } catch (err) {
       alert(" Failed");
     }


   };

  return (
    <div>
      <div className="row">
        <Header />
        <div className="col-10" style={{ overflowY: 'scroll', height: '100vh', scrollbarWidth: 'none' }}>
          <p style={{ fontWeight: '700', marginTop: 10 }} >Upload Fraud data</p>
          <div className="row" style={{ position: 'sticky', top: 0, backgroundColor: '#fff', }}>
            <div className="col-6">
              <p>Enter data : </p>
              <textarea
                onChange={(e) => {
                  setName(e.target.value)
                }}
                type="text"
                style={{ width: "100%" }}
                placeholder="[ 'n' , 'n+1' , ....... ]"
              />

              <div style={{ display: "flex", gap: 20 }}>
                <label>
                  <input
                    type="radio"
                    name="fruit"
                    value="phone"
                    checked={selectedRadio === "phone"}
                    onChange={(e) => setSelectedRadio(e.target.value)}
                  />
                  Phone No
                </label>

                <label>
                  <input
                    type="radio"
                    name="fruit"
                    value="email"
                    checked={selectedRadio === "email"}
                    onChange={(e) => setSelectedRadio(e.target.value)}
                  />
                  Email
                </label>

                <label>
                  <input
                    type="radio"
                    name="fruit"
                    value="account"
                    checked={selectedRadio === "account"}
                    onChange={(e) => setSelectedRadio(e.target.value)}
                  />
                  Account No
                </label>
              </div>

              {/* Display selected values */}
              <div style={{ marginTop: 30 }}>
                <button className="mt-4" onClick={() => {
                  User()
                }} >
                  Submit
                </button>
              </div>
            </div>
            <div className="col-6">

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Fraud;
